/**
 * 共用事件常數
 */
export const CommonEvent = {
  /** 開啟共用彈窗 */
  OPEN_DIALOG: 'emitter:common:open-dialog',
  /** 關閉共用彈窗 */
  CLOSE_DIALOG: 'emitter:common:close-dialog',
  /** 更新列表資料 */
  REFRESH_LIST: 'emitter:common:refresh-list',
  /** 分類標記已更新（包含被刪除的標記 ID） */
  ORG_TAG_UPDATED: 'emitter:common:org-tag-updated'
} as const

export type CommonEvent = (typeof CommonEvent)[keyof typeof CommonEvent]
